export default __webpack_public_path__ + "static/media/zoology.e5a208de.svg";